module.exports = __webpack_public_path__ + "static/media/type-scatter.065f1cd3.svg";